'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _carousel = require('./carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

// Handles negative numbers
function universalModulus(x, y) {
  return x < 0 ? (x + Math.ceil(Math.abs(x) / y) * y) % y : x % y;
}

// These callbacks ensure that a mouse drag isn't treated as a click. The number of pixels travelled must be
// less than the value of this.props.dragThreshold to count as a click.
function makeMouseDragCallbacks() {
  var dragThreshold = arguments.length <= 0 || arguments[0] === undefined ? 40 : arguments[0];

  var mouseDown = false;
  var origin = [];
  var distanceMoved = 0;

  return {
    onMouseDown: function onMouseDown(event) {
      mouseDown = true;
      origin = [event.pageX, event.pageY];
      distanceMoved = 0;
    },
    onMouseMove: function onMouseMove(event) {
      if (mouseDown) {
        var delta = Math.abs(origin[0] - event.pageX) + Math.abs(origin[1] - event.pageY);
        distanceMoved += delta;
        origin = [event.pageX, event.pageY];
      }
    },
    onClickCapture: function onClickCapture(event) {
      if (distanceMoved >= dragThreshold) {
        event.stopPropagation();
        event.preventDefault();
      }
      mouseDown = false;
      distanceMoved = 0;
    }
  };
}

// Calculate the nearest path from 'indexB' to 'indexA' on a wrap-around carousel of 'total' items.
function getWrappedDistance(indexA, indexB, total) {
  var rightMagnitude = (indexA + total - indexB) % total;
  var leftMagnitude = (indexB + total - indexA) % total;
  if (leftMagnitude < rightMagnitude) {
    return -leftMagnitude;
  } else {
    return rightMagnitude;
  }
}

function wrapAroundCarousel(WrappedCarousel) {
  var WrapAroundCarousel = (0, _createReactClass2['default'])({

    getDefaultProps: function getDefaultProps() {
      return {
        beforeSlide: function beforeSlide() {}
      };
    },

    // Take the closest path to the destination photo
    goToSlide: function goToSlide(index) {
      var closestJump = getWrappedDistance(index, this.carousel.state.currentSlide, this.total);
      var shiftedIndex = this.carousel.state.currentVirtualSlide + closestJump;
      this.carousel.goToSlide(shiftedIndex);
    },

    componentWillMount: function componentWillMount() {
      this.total = _react2['default'].Children.count(this.props.children);
    },

    render: function render() {
      var _this = this;

      return _react2['default'].createElement(
        WrappedCarousel,
        _extends({
          ref: function (ref) {
            _this.carousel = ref;
          },
          wrapAround: true
        }, this.props, {
          beforeSlide: function (oldIndex, newIndex) {
            _this.props.beforeSlide(oldIndex, newIndex);
          }
        }),
        this.props.children
      );
    }
  });
  (0, _hoistNonReactStatics2['default'])(WrapAroundCarousel, WrappedCarousel);
  WrapAroundCarousel.displayName = 'WrapAroundCarousel(' + WrappedCarousel.displayName + ')';
  return WrapAroundCarousel;
}

var WrapAroundCarousel = wrapAroundCarousel(_carousel2['default']);
exports.makeMouseDragCallbacks = makeMouseDragCallbacks;
exports.WrapAroundCarousel = WrapAroundCarousel;
exports.getWrappedDistance = getWrappedDistance;
exports.universalModulus = universalModulus;